import React, { createContext, useContext } from 'react';

import { useLocalStore } from '@/hooks/useLocalStore';

import { TrackerStore } from './TrackerStore';

const TrackerStoreContext = createContext<TrackerStore | null>(null);

export const TrackerStoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { store } = useLocalStore(() => new TrackerStore());

  return <TrackerStoreContext.Provider value={store}>{children}</TrackerStoreContext.Provider>;
};

export function useTrackerStore() {
  const store = useContext(TrackerStoreContext);

  if (!store) throw new Error('useTrackerStore must be used within TrackerStoreProvider');

  return store;
}
